import CardioChirurgiaEdit from "./components/CardioChirurgiaEdit.vue";
import CardioChirurgiaView from "./components/CardioChirurgiaView.vue";
import CardioChirurgiaList from "./components/CardioChirurgiaList.vue";

export default {
    CardioChirurgiaEdit,
    CardioChirurgiaView,
    CardioChirurgiaList,
};
